import * as turf from '@turf/turf';
import mapboxgl from 'mapbox-gl';


const sources_ids = ['sourceCommoditiesRestaurant'];
const layers_ids = ['layerCommoditiesRestaurant_Points'];
var markers = [];
var marker_img = '<svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M558.704 349.907C575.129 349.952 591.401 346.738 606.576 340.451C621.751 334.164 635.528 324.93 647.11 313.282L767.422 193.047C776.938 183.532 777.813 168.047 768.751 158.063C766.475 155.554 763.714 153.534 760.635 152.125C757.556 150.716 754.222 149.947 750.836 149.865C747.451 149.784 744.084 150.39 740.94 151.649C737.796 152.908 734.941 154.792 732.547 157.188L625.313 264.344C621.712 267.94 616.832 269.96 611.743 269.96C606.654 269.96 601.773 267.94 598.172 264.344C590.688 256.875 591.094 244.25 598.563 236.782L705.329 130.016C707.722 127.623 709.604 124.768 710.861 121.626C712.119 118.483 712.725 115.118 712.643 111.735C712.561 108.351 711.793 105.019 710.385 101.941C708.978 98.8635 706.96 96.1034 704.454 93.8285C699.929 89.7248 694.031 87.4668 687.922 87.5004C681 87.5051 674.362 90.2591 669.469 95.1566L562.797 201.813C559.197 205.409 554.316 207.429 549.227 207.429C544.138 207.429 539.257 205.409 535.657 201.813C528.188 194.344 528.579 181.719 536.047 174.25L642.813 67.516C645.206 65.1226 647.088 62.2682 648.346 59.1258C649.603 55.9834 650.209 52.6184 650.127 49.2348C650.045 45.8512 649.277 42.5194 647.87 39.4415C646.462 36.3635 644.444 33.6034 641.938 31.3285C637.414 27.2248 631.515 24.9668 625.407 25.0004C618.485 25.0086 611.848 27.762 606.954 32.6566L486.719 152.891C475.07 164.475 465.835 178.255 459.548 193.433C453.261 208.61 450.048 224.885 450.094 241.313V254.172C450.097 257.46 449.451 260.716 448.193 263.754C446.936 266.791 445.092 269.551 442.766 271.875L387.126 327.532C386.545 328.113 385.856 328.574 385.097 328.888C384.338 329.203 383.525 329.365 382.704 329.365C381.882 329.365 381.069 329.203 380.31 328.888C379.552 328.574 378.862 328.113 378.282 327.532L107.532 56.766C102.859 52.0877 96.5228 49.4513 89.9105 49.4337C83.2982 49.4161 76.9483 52.0189 72.2505 56.6722C48.5787 80.1254 35.938 113.235 35.938 152.407C35.7818 217.094 69.7818 291.469 124.672 346.282L258.188 479.797C277.165 498.735 302.878 509.373 329.688 509.375C338.235 509.379 346.747 508.287 355.016 506.125C357.092 505.582 359.229 505.303 361.376 505.297C367.652 505.298 373.696 507.67 378.297 511.938L396.094 528.375C400.684 533.065 403.263 539.36 403.282 545.922V554.578C403.236 574.257 410.97 593.156 424.797 607.157L565.501 750.235L565.641 750.391C581.258 766.006 602.438 774.777 624.522 774.776C646.606 774.774 667.784 766 683.399 750.383C699.014 734.766 707.785 713.587 707.784 691.503C707.782 669.419 699.008 648.24 683.391 632.625L472.485 421.719C471.904 421.139 471.443 420.449 471.128 419.691C470.814 418.932 470.652 418.119 470.652 417.297C470.652 416.476 470.814 415.663 471.128 414.904C471.443 414.145 471.904 413.456 472.485 412.875L528.126 357.235C530.448 354.911 533.205 353.068 536.24 351.81C539.275 350.553 542.528 349.906 545.813 349.907H558.704Z" fill="white"/><path d="M329.688 559.375C289.662 559.293 251.282 543.432 222.875 515.234L201.219 493.578C198.875 491.241 195.701 489.928 192.391 489.928C189.081 489.928 185.906 491.241 183.562 493.578L50.75 625.703C27.0781 649.375 18.625 684.219 30.3437 718.344C30.9996 720.266 31.7772 722.145 32.6719 723.969C48.4375 756.25 79.0312 775 112.5 775C124.01 775.028 135.411 772.773 146.043 768.363C156.675 763.954 166.326 757.479 174.437 749.313L351.562 571.344C352.308 570.583 352.879 569.669 353.235 568.665C353.591 567.661 353.724 566.592 353.625 565.531V565.125C353.556 564.151 353.289 563.201 352.843 562.332C352.396 561.463 351.778 560.694 351.026 560.071C350.275 559.447 349.404 558.982 348.468 558.704C347.531 558.426 346.548 558.341 345.578 558.453C340.301 559.038 334.997 559.346 329.688 559.375Z" fill="white"/></svg>';
var marker_img2 = '<svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_1133_4)"><path d="M725.042 330.459C698.373 303.489 660.967 287.355 620.559 287.419C608.128 287.403 595.472 289.35 582.816 292.414C591.897 274.955 597.114 255.166 597.114 234.116C597.083 186.544 570.719 145.305 531.923 123.697C512.327 52.361 447.214 0.0468991 369.734 2.40556e-05C340.594 -0.0156009 313.161 7.58127 289.253 20.6516C270.853 9.33596 249.148 2.68284 225.959 2.69846C168.092 2.74534 119.928 43.2485 107.816 97.461C63.5469 115.063 32.1891 158.023 32.1406 208.598C32.1406 241.697 45.5453 271.636 67.2016 293.323V670.159C67.2016 741.878 125.323 800 197.027 800H415.136C486.839 800 544.977 741.878 544.977 670.159V622.459C551.202 623.033 557.456 623.369 563.744 623.369C606.609 623.258 650.816 610.522 688.416 584.494C707.166 571.441 724.164 554.891 737.633 534.816C751.117 514.77 760.948 491.169 765.402 465.059C767.045 455.452 767.859 445.925 767.859 436.574C767.939 395.238 751.819 357.35 725.042 330.459ZM534.205 278.273H140.022C125.277 275.752 112.109 268.889 101.928 258.723C89.0656 245.814 81.1812 228.259 81.1656 208.598C81.1156 175.259 104.336 147.284 135.378 139.783L152.597 135.617L154.047 117.952C157.08 80.9422 188.103 51.6735 225.958 51.7235C243.736 51.7375 259.742 58.0735 272.43 68.7016L286.745 80.7344L302.13 70.1078C321.406 56.7969 344.531 49.0422 369.731 49.025C427.597 48.9781 475.856 90.3578 486.694 145.017L489.198 157.689L501.072 162.781C528.712 174.7 548.119 202.119 548.086 234.116C548.075 250.633 542.917 265.731 534.205 278.273ZM684.873 451.236C682.32 465.983 677.102 478.334 669.792 489.281C658.861 505.592 642.758 518.773 623.783 527.87C604.888 536.967 583.327 541.691 563.745 541.658C557.155 541.675 550.916 541.02 544.978 540.03V405.784C553.517 397.391 561.942 390.622 570.033 385.452C588.866 373.452 605.845 369.159 620.559 369.127C639.503 369.173 655.319 376.292 667.031 388.006C678.633 399.816 686.069 416.094 686.15 436.569C686.15 441.23 685.752 446.113 684.873 451.236Z" fill="white"/></g><defs><clipPath id="clip0_1133_4"><rect width="800" height="800" fill="white"/></clipPath></defs></svg>';
var marker_img3 = '<svg width="14" height="14" viewBox="0 0 800 800" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 300.4L100 50H700L800 300.4C800 328.133 790.133 351.6 770.4 370.8C750.667 390 727.2 399.867 700 400.4C672.8 400.933 649.333 391.067 629.6 370.8C609.867 350.533 600 327.067 600 300.4C600 328.133 590.133 351.6 570.4 370.8C550.667 390 527.2 399.867 500 400.4C472.8 400.933 449.333 391.067 429.6 370.8C409.867 350.533 400 327.067 400 300.4C400 328.133 390.133 351.6 370.4 370.8C350.667 390 327.2 399.867 300 400.4C272.8 400.933 249.333 391.067 229.6 370.8C209.867 350.533 200 327.067 200 300.4C200 328.133 190.133 351.6 170.4 370.8C150.667 390 127.2 399.867 100 400.4C72.8 400.933 49.3333 391.067 29.6 370.8C9.86667 350.533 0 327.067 0 300.4ZM100 750V450C137.867 450 171.2 437.2 200 411.6V650H600V411.6C628.8 437.2 662.133 450 700 450V750H100Z" fill="white"/></svg>';

export const get_ids = () => {
    // Get all source ids
    var sources = [];
    sources_ids.forEach(source_id => {
        sources.push({ id: source_id });
    })
    // Get all layer ids
    var layers = [];
    layers_ids.forEach(layer_id => {
        layers.push({ id: layer_id });
    })

    return {
        sources: sources,
        layers: layers,
        markers: markers,
    }
}


export const get_data = (capacity) => {
    // Set map data
    var map_data = {
        sources: [],
        layers: [],
        markers: [],
        bbox: null
    }

    var data_items = capacity?.context?.commodities?.leisure_food?.items?.bar_cafe || [];
    var data_cat = Array(data_items.length).fill("Bar / Café");
    var data_img = Array(data_items.length).fill(marker_img2);
    if (capacity?.context?.commodities?.leisure_food?.items?.marketplace) {
        data_items = data_items.concat(capacity?.context?.commodities?.leisure_food?.items?.marketplace);
        data_cat = data_cat.concat(Array(capacity?.context?.commodities?.leisure_food?.items?.marketplace.length).fill("Marché"));
        data_img = data_img.concat(Array(capacity?.context?.commodities?.leisure_food?.items?.marketplace.length).fill(marker_img3));
    }
    if (capacity?.context?.commodities?.leisure_food?.items?.restaurant) {
        data_items = data_items.concat(capacity?.context?.commodities?.leisure_food?.items?.restaurant);
        data_cat = data_cat.concat(Array(capacity?.context?.commodities?.leisure_food?.items?.restaurant.length).fill("Restaurant"));
        data_img = data_img.concat(Array(capacity?.context?.commodities?.leisure_food?.items?.restaurant.length).fill(marker_img));
    }


    // Check needed data
    if (!data_items.length > 0) {
        return map_data
    }

    // Preset layer data
    var layer_data = {
        type: 'FeatureCollection',
        features: [],
    };

    // Add data
    for (var i = 0; i < data_items.length; i++) {
        var item = data_items[i];
        var item_marker_coords = null;
        // Generate polygon
        if (item?.type === "way" && item?.coords && item.coords.length > 3 && item.coords[0].length === 2 && item.coords[0][0] === item.coords[item.coords.length - 1][0] && item.coords[0][1] === item.coords[item.coords.length - 1][1]) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Polygon",
                    coordinates: [item.coords],
                }
            });
            try {
                var center = turf.centroid(turf.polygon([item.coords]));
                item_marker_coords = center?.geometry?.coordinates || null;
            } catch (error) {
                item_marker_coords = null;
            }
        }
        // Generate point
        else if (item?.type === "node" && item?.coords && item.coords.length === 2) {
            layer_data.features.push({
                type: "Feature",
                properties: item?.properties || null,
                geometry: {
                    type: "Point",
                    coordinates: item.coords,
                }
            });
            item_marker_coords = item.coords;
        }
        // Generate marker
        if (item_marker_coords !== null && item_marker_coords.length === 2) {
            var title = data_cat.length >= (i-1) ? data_cat[i] : "Restaurant / Bar / Café";
            var img_i = data_img.length >= (i-1) ? data_img[i] : marker_img;
            var title_txt = '<span style="color:#062134;font-size:15px;font-weight:700"><strong>' + title + '</strong></span>';
            var infos = [
                { label: "Nom", value: item?.properties?.name || "NC" },
                { label: "Distance", value: item?.properties?.distance ? item?.properties?.distance + " m" : "NC"},
            ]
            var infos_txt = infos.map(info => { return ('<br /><span style="font-size:12px;font-weight: 600;color: grey;">' + info.label + ' :</span><br /><span style="color:#062134;font-weight:500;">' + info.value + '</span>') }).join('');
            var marker_label = item?.properties?.name || "Restaurant / Bar / Café";
            var el = document.createElement('div');
            el.className = 'marker';
            el.innerHTML = '<div style="cursor:pointer;padding:3px 8px 2px;background-color:#062134;border-radius:6px;display:flex;justify-content:center;align-items:center;gap:4px"><div style="display:flex;justify-content:center">' + img_i + '</div><div style="font-family:Manrope;color:#FFF;">' + marker_label + '</div></div>';
            map_data.markers.push(new mapboxgl.Marker(el)
                .setLngLat(item_marker_coords)
                .setPopup(new mapboxgl.Popup({ offset: 15 })
                    .setHTML('<p style="font-family:Manrope">' + title_txt + infos_txt + '</p>'))
            )
        }
    }

    // Check data exists
    if (!layer_data.features.length > 0) {
        return map_data
    }

    // Create sources
    map_data.sources.push(
        {
            id: sources_ids[0],
            value: {
                type: 'geojson',
                data: layer_data
            }
        }
    )

    // Create layers
    map_data.layers.push(
        {
            id: layers_ids[0],
            type: 'fill',
            source: sources_ids[0],
            paint: {
                'fill-color': '#062134',
                'fill-opacity': 0.5,
            },
            filter: ['in', '$type', 'Polygon']
        }
    );

    // Set global markers
    if (map_data.markers.length > 0) {
        markers = map_data.markers;
    }
    else {
        markers = [];
    }

    // Get bbox
    var bbox_data = {
        type: 'FeatureCollection',
        features: layer_data.features.concat([capacity?.landBase?.union?.geometry]),
    };
    var bbox = turf.bbox(bbox_data);
    if (bbox && bbox.length === 4) {
        var bbox_poly = [
            [bbox[0], bbox[1]],
            [bbox[2], bbox[1]],
            [bbox[2], bbox[3]],
            [bbox[0], bbox[3]],
            [bbox[0], bbox[1]],
        ]
        map_data.bbox = [bbox_poly];
    }


    // Return
    // console.log("map_data", map_data);
    return map_data

}

